import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { deleteRequestedLoan } from 'services/loans'
interface IPayload {
    id: string | undefined
    loanId: number
}
export default function useDeleteLoan(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IPayload) => {
            return deleteRequestedLoan(payload)
        },
        onSuccess: (_, variables) => {
            toast.success('درخواست وام با موفقیت لغو شد')
            refetch()
        },
        onError: () => {
            toast.error('مشکلی در لغو وام پیش آمده!')
        },
    })
    return { isLoading, mutate }
}
